export const NAMESPACE = "UploadDocumentTemplateModal";
